import React from "react";
import { Link } from "react-router-dom";
import {
  FaUsers,
  FaAtom,
  FaHandshake,
  FaChevronRight,
} from "react-icons/fa";
import "./Team.css";

// Images
import presidentImg from "../../assets/images/president.png";
import vicePresidentImg from "../../assets/images/nduma.png";
import johnImg from "../../assets/images/john.png";
import georgeImg from "../../assets/images/george.png";
import treasurerImg from "../../assets/images/treasurer.png";
import kerenImg from "../../assets/images/keren.jpg";
import peterImg from "../../assets/images/peter.png";
import recruitmentCommunicationImg from "../../assets/images/ruth.png";
import advocacyStakeholderImg from "../../assets/images/allan.png";
import collinsImg from "../../assets/images/collins.png";
import brendaImg from "../../assets/images/brenda.png";
import pamellaImg from "../../assets/images/pamella.png";
import gladysImg from "../../assets/images/gladys.png";
import michelleImg from "../../assets/images/michelle.png";
import victorImg from "../../assets/images/victor.png";
import hashimImg from "../../assets/images/hashim.png";
import mwauraImg from "../../assets/images/mwaura.png";
import vainaduImg from "../../assets/images/vainadu.png";
import nderituImg from "../../assets/images/nderitu.png";
import naomiImg from "../../assets/images/naomi.png";
import ruthImg from "../../assets/images/ruth.png";
import christerImg from "../../assets/images/christer.png";
import brianImg from "../../assets/images/brian.png";
import linnetImg from "../../assets/images/linnet.png";
import elizabethImg from "../../assets/images/elizabeth.png";
import cliffImg from "../../assets/images/cliff.png";
import zephaniaImg from "../../assets/images/zephania.png";


// Executive Committee
const executiveCommittee = [
  {
    name: "Dr David Otwoma",
    role: "Founding President",
    image: presidentImg,
  },
  {
    name: "Eng. Ndumah Ruwah",
    role: "President",
    image: vicePresidentImg,
  },
  {
    name: "George Maweu",
    role: "Vice President",
    image: georgeImg,
  },
  {
    name: "Joe Mwangi",
    role: "Treasurer",
    image: treasurerImg,
  },
  {
    name: "Keren Omondi",
    role: "Secretary General",
    image: kerenImg,
  },
  
  {
    name: "John Birir ",
    role: "Assistant Secretary",
    image: johnImg,
  },
  {
    name: "Peter Gichuki",
    role: "Technical Lead",
    image: peterImg,
  },
  {
    name: "Ruth Achieng",
    role: "Recruitment & Communication Representative",
    image: recruitmentCommunicationImg,
  },
  {
    name: "Allan Ong'onge",
    role: "Advocacy & Stakeholder Engagement Representative",
    image: advocacyStakeholderImg,
  },
  {
    name: "Collins Omondi",
    role: "Resource Mobilization Representative",
    image: collinsImg,
  },
];

// Active Committees
const committees = [
  {
    title: "Committee on Constitutional Review",
    members: [
      { name: "Joe Mwangi", image: treasurerImg, slug: "joe-mwangi" },
      { name: "Eng. Ndumah Ruwah", image: vicePresidentImg, slug: "eng-ndumah-ruwah" },
      { name: "Dr. Pamella Kageliza Kilavi", image: pamellaImg, slug: "dr-pamella-kageliza-kilavi" },
      { name: "Brenda Masiza", image: brendaImg, slug: "brenda-masiza" },
      { name: "Keren Omondi", image: kerenImg, slug: "keren-omondi" },
      { name: "John Birir", image: johnImg, slug: "john-birir" },
    ],
  },
  {
    title: "Education & Scholarship",
    members: [
      { name: "Dr. Gladys Ngetich", image: gladysImg, slug: "dr-gladys-ngetich" },
      { name: "Michelle Watiki", image: michelleImg, slug: "michelle-watiki" },
      { name: "Victor Mutava", image: victorImg, slug: "victor-mutava" },
      { name: "Dr. Nadir Hashim", image: hashimImg, slug: "dr-nadir-hashim" },
      { name: "Dr. Anselim Mwaura", image: mwauraImg, slug: "dr-anselim-mwaura" },
      { name: "Vainadu Ingana", image: vainaduImg, slug: "vainadu-ingana" },
      { name: "Nderitu James Kiiro", image: nderituImg, slug: "nderitu-james-kiiro" },
      { name: "Dr. Naomi Mburu", image: naomiImg, slug: "dr-naomi-mburu" },
    ],
   
  },
  {
    title: "Recruitment & Mentorship",
    members: [
      { name: "Ruth Achieng", image: ruthImg, slug: "ruth-achieng" },
      { name: "Christer Anditi", image: christerImg, slug: "christer-anditi" },
      { name: "Michelle Watiki", image: michelleImg, slug: "michelle-watiki" },
      { name: "Brian Nyawinda", image: brianImg, slug: "brian-nyawinda" },
      { name: "Linnet Nyamweya", image: linnetImg, slug: "linnet-nyamweya" },
      { name: "Elizabeth Itotiah Itotia", image: elizabethImg, slug: "elizabeth-itotiah-itotia" },
      { name: "Allan Ong'onge", image: advocacyStakeholderImg, slug: "allan-ong'onge" },
    ],
  },
  {
    title: "Committee on Resource Mobilization",
    members: [
      { name: "Dr. Nadir Hashim", image: hashimImg, slug: "dr-nadir-hashim" },
      { name: "Collins Omondi", image: collinsImg, slug: "collins-omondi" },
    ],
  },
  {
    title: "Advocacy, Communication & Stakeholder Engagement",
    members: [
      { name: "Christer Anditi", image: christerImg, slug: "christer-anditi" },
      { name: "Cliff Ukhevi Wesonga", image: cliffImg, slug: "cliff-ukhevi-wesonga" },
      { name: "Zephania Mege", image: zephaniaImg, slug: "zephania-mege" },
    ],
  },
];


function Team() {
  return (
    <main className="team">
      {/* Hero */}
      <section className="team__hero">
        <div className="container">
          <span className="team__badge">
            Our Leadership & Committees
          </span>

          <h1>Meet the People Behind the Nuclear Society of Kenya</h1>

          <p>
            The Nuclear Society of Kenya is driven by dedicated
            professionals, researchers, engineers, educators and
            volunteers working together to advance the peaceful use of
            nuclear science and technology.
          </p>
        </div>
      </section>

      {/* Executive Committee */}
      <section className="team__section">
        <div className="container">
          <div className="team__heading">
            <FaUsers />

            <div>
              <h2>Executive Committee</h2>

              <p>
                The elected leadership responsible for the governance,
                strategy and overall direction of the Society.
              </p>
            </div>
          </div>

          <div className="team__grid">
            {executiveCommittee.map((member) => (
              <article
                className="member-card"
                key={member.name}
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="member-card__image"
                />

                <h3>{member.name}</h3>

                <span className="member-card__role">
                  {member.role}
                </span>
              </article>
            ))}
          </div>
        </div>
      </section>

     {/* Active Committees */}
<section className="team__section team__section--light">
  <div className="container">
    <div className="team__heading">
      <FaAtom />

      <div>
        <h2>Active Committees</h2>

        <p>
          NSK committees support education, advocacy, recruitment,
          constitutional review, stakeholder engagement, and resource
          mobilization across the Society.
        </p>
      </div>
    </div>

    <div className="committee-grid">
      {committees.map((committee) => (
        <div className="committee-card" key={committee.title}>
          <FaAtom className="committee-card__icon" />

          <h3>{committee.title}</h3>

          <div className="committee-members">
            {committee.members.map((member) => (
              <Link
                key={member.slug}
                to={`/team/${member.slug}`} 
                className="committee-member"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="committee-member__image"
                />

                <p className="committee-member__name">
                  {member.name}
                </p>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* CTA */}
      <section className="team__cta">
        <div className="container">
          <FaHandshake className="team__cta-icon" />

          <h2>Want to Serve on a Committee?</h2>

          <p>
            NSK welcomes professionals, researchers and students who
            wish to contribute their expertise and help strengthen
            Kenya's nuclear science community.
          </p>

          <Link to="/join" className="btn btn--primary">
            Join NSK
            <FaChevronRight style={{ marginLeft: "8px" }} />
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Team;
